import { render, staticRenderFns } from "./ParamsBatchDetail.vue?vue&type=template&id=46a20ff5&scoped=true"
import script from "./ParamsBatchDetail.vue?vue&type=script&lang=js"
export * from "./ParamsBatchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a20ff5",
  null
  
)

export default component.exports